import {inject, Injectable} from '@angular/core';
import Keycloak from 'keycloak-js';

@Injectable({
    providedIn: 'root'
})
export class PreloadService {
    private keycloak: Keycloak;

    constructor(
    ) {
        this.keycloak = inject(Keycloak);
    }

    init(): void {
        this.keycloak.onAuthSuccess = () => {
            this.preload();
        }
    }

    preload(): void {}
}

export function initCpePreload(preloadService: PreloadService) {
    return () => preloadService.init();
}
